import { AppRouter } from './router'
import { AuthProvider } from './context/AuthContext'
import { Toaster } from 'sonner'
import './App.css'

function App() {
  return (
    <AuthProvider>
      <AppRouter />
      <Toaster position='top-right' richColors />
    </AuthProvider>
  )
}

export default App
